export default "__VITE_ASSET__5a6adfa7__"